<ngx-loading-bar [color]="'#ffcc00'" [height]="'5px'">
  <div class="loader-div"></div>
</ngx-loading-bar>
<div class="mat-drawer-container">
  <app-theme-switch></app-theme-switch> 
  <router-outlet></router-outlet>
</div>
